const orderBilling = () => import('@/views/main/order/billing/index.vue')
export default {
  path: '/main/order/billing',
  name: 'orderBilling',
  component: orderBilling,
  children: []
}
